export default "__VITE_ASSET__C$Pgq418__"